import React, { Component } from 'react';
import { connect } from 'react-redux';
import CheckmarksComponent from './CheckmarksComponent';

class Checkmarks extends Component {
  render() {
    const { hideHighlights, airlineWhitelabel, homeBoxesIntoView } = this.props;
    const showFlightCarriers = !airlineWhitelabel;
    const showHighlights = airlineWhitelabel ? true : !hideHighlights;

    return (
      <CheckmarksComponent
        showFlightCarriers={showFlightCarriers}
        showHighlights={showHighlights}
        homeBoxesIntoView={homeBoxesIntoView}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
    homeBoxesIntoView: state.intersectionObserver.elements.homeBoxes,
  };
}

export default connect(mapStateToProps)(Checkmarks);
